import FreeTrial from './FreeTrial';

export default FreeTrial;
